
// https://github.com/tensorflow/tfjs-models/blob/master/face-landmarks-detection/src/constants.ts

// const LIPS_CONNECTIONS: PairArray = [
window.LIPS_MEST = [
  [61, 146],  [146, 91],  [91, 181],  [181, 84],  [84, 17],   [17, 314],
  [314, 405], [405, 321], [321, 375], [375, 291], [61, 185],  [185, 40],
  [40, 39],   [39, 37],   [37, 0],    [0, 267],   [267, 269], [269, 270],
  [270, 409], [409, 291], [78, 95],   [95, 88],   [88, 178],  [178, 87],
  [87, 14],   [14, 317],  [317, 402], [402, 318], [318, 324], [324, 308],
  [78, 191],  [191, 80],  [80, 81],   [81, 82],   [82, 13],   [13, 312],
  [312, 311], [311, 310], [310, 415], [415, 308],
];

window.lips_out_bot = [
  61, 146, 91, 181, 84, 17, 314, 405, 321, 375, 291,
];

window.lips_out_top = [
  61, 185, 40, 39, 37, 0, 267, 269, 270, 409, 291,
];

window.lips_in_bot = [
  78, 95, 88, 178, 87, 14, 317, 402, 318, 324, 308,
];

window.lips_in_top = [
  78, 191, 80, 81, 82, 13, 312, 311, 310, 415, 308,
];
